const init = () => {
    const onButtonClick = () => {
        const url = button.getAttribute('data-url');
        const formError = document.getElementById('form-error');
        const selectedUuid = document.getElementById('medicalCenter').value;
        const termsAreAccepted = document.getElementById('terms').checked;

        if (!termsAreAccepted) {
            formError.textContent = 'Debes aceptar los términos y condiciones para continuar.';
            formError.classList.remove('tw-hidden');
            formError.classList.add('tw-block');
            return;
        }

        if (!selectedUuid) {
            formError.textContent = 'Debes seleccionar un centro médico para continuar.';
            formError.classList.remove('tw-hidden');
            formError.classList.add('tw-block');
            return;
        }
        formError.classList.add('tw-hidden');
        formError.classList.remove('tw-block');

        window.location.href = `${url}/${selectedUuid}`;
    };

    const button = document.getElementById('scheduling-continue');
    if (button) {
        button.addEventListener('click', onButtonClick);
    }

    const container = document.querySelector('#scheduling-container');
    if (!container) {
        return;
    }
    const thankYouPageURL = container.getAttribute('data-thanks');

    const handleMessage = (event) => {
        switch (event.data) {
            case 'SCHEDULING_SUCCESSFUL':
                window.location.href = thankYouPageURL;
        }
    };

    window.addEventListener('message', handleMessage, false);
};

export default init;
